<div class="pdf" [class.pdf--fuellen]="fuellen()">
  @if (modus() === 'leer') {
    <p class="leer mat-body-medium">Kein PDF vorhanden</p>
  } @else {
    <div class="leiste" role="toolbar" aria-label="Ansicht des Dokuments">
      @if (modus() === 'eigen') {
        <span class="seitenzahl mat-label-large">
          <span class="lang">Seite {{ aktuelleSeite() }} von {{ seitenAnzahl() }}</span>
          <span class="kurz">{{ aktuelleSeite() }} / {{ seitenAnzahl() }}</span>
        </span>
        <span class="luecke"></span>
        <button type="button" matIconButton (click)="verkleinern()" [disabled]="prozent() <= zoomMin" matTooltip="Verkleinern">
          <mat-icon>remove</mat-icon>
        </button>
        <button type="button" matButton class="zoomwahl" [matMenuTriggerFor]="zoomMenue" matTooltip="Zoomstufe wählen">
          {{ zoomText() }}
          <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
        </button>
        <button type="button" matIconButton (click)="vergroessern()" [disabled]="prozent() >= zoomMax" matTooltip="Vergrößern">
          <mat-icon>add</mat-icon>
        </button>
        <button type="button" matIconButton (click)="drehen()" matTooltip="Drehen">
          <mat-icon>rotate_right</mat-icon>
        </button>
      }
      <span class="luecke"></span>
      <button type="button" matButton class="herunterladen-breit" (click)="herunterladen()">
        <mat-icon>download</mat-icon>
        Herunterladen
      </button>
      <button type="button" matIconButton class="herunterladen-schmal" (click)="herunterladen()" matTooltip="Herunterladen">
        <mat-icon>download</mat-icon>
      </button>
      <a matIconButton [href]="url()" target="_blank" rel="noopener" matTooltip="In neuem Tab öffnen. Dort lässt es sich auch drucken.">
        <mat-icon>open_in_new</mat-icon>
      </a>
    </div>

    <mat-menu #zoomMenue="matMenu">
      <button type="button" mat-menu-item (click)="passeEin('seitenbreite')">Seitenbreite</button>
      <button type="button" mat-menu-item (click)="passeEin('ganzeSeite')">Ganze Seite</button>
      @for (stufe of zoomStufen; track stufe) {
        <button type="button" mat-menu-item (click)="setzeProzent(stufe)">{{ stufe }} %</button>
      }
    </mat-menu>

    <div class="inhalt" [style.aspect-ratio]="fuellen() ? null : seitenformat()">
      @switch (modus()) {
        @case ('laedt') {
          <div class="mitte">
            <mat-spinner diameter="32" />
          </div>
        }
        @case ('eigen') {
          @let _dokument = dokument();
          <div
            #flaeche
            class="flaeche"
            [class.verschiebbar]="verschiebbar()"
            [class.zieht]="zieht()"
            role="region"
            tabindex="0"
            [attr.aria-label]="seitenAnzahl() === 1 ? 'Dokument mit einer Seite' : 'Dokument mit ' + seitenAnzahl() + ' Seiten'"
            (scroll)="beimScrollen()"
          >
            <div class="seiten">
              @if (_dokument) {
                @for (seite of seiten(); track seite.nummer) {
                  <lib-pdf-seite
                    [dokument]="_dokument"
                    [nummer]="seite.nummer"
                    [skala]="skala()"
                    [drehung]="drehung()"
                    [breite]="seite.breite"
                    [hoehe]="seite.hoehe"
                    [wurzel]="flaeche"
                    (springeZu)="zeigeSeite($event)"
                  />
                }
              }
            </div>
          </div>
        }
        @case ('browser') {
          <!--
            Rueckfall, wenn pdf.js das Dokument nicht zeichnen kann. Der Inhalt des <object> erscheint,
            wenn auch der Browser das PDF nicht selbst anzeigt: in Edge etwa, wenn eine Firmenrichtlinie
            PDFs immer extern oeffnet oder Adobe als PDF-Programm gesetzt ist.
          -->
          <object class="browser" [data]="sichereUrl()" type="application/pdf">
            <div class="pdf-ersatz">
              <mat-icon>picture_as_pdf</mat-icon>
              <p class="mat-body-medium">Die Vorschau lässt sich in diesem Browser nicht anzeigen.</p>
              <a matButton="tonal" [href]="url()" target="_blank" rel="noopener">PDF öffnen</a>
            </div>
          </object>
        }
      }
    </div>
  }
</div>
